import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { SvgIconsDirective } from './directive/svg-icon-directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { InitialComponent } from './initial/initial.component';
import { SharedService } from './shared.service';
import { BsDropdownModule } from 'ngx-bootstrap';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import { TranslateModule } from '@ngx-translate/core';
import { TreeTableModule } from 'primeng/treetable';
import { SideNavigationService } from './side-navigation/side-navigation.service';
import { PageNotFoundService } from './error-pages/page-not-found.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TreeModule } from 'primeng/tree';
import { ResetPasswordService } from './reset-password/reset-password.service';
import { PageNotFoundComponent } from './error-pages/page-not-found.component';
import { ServerErrorComponent } from './error-pages/server-error/server-error.component';
import { AccessDeniedComponent } from './error-pages/access-denied/access-denied.component';
import { ServerUnavailableComponent } from './error-pages/server-unavailable/server-unavailable.component';
import { TimeOutComponent } from './error-pages/time-out/time-out.component';
import { FooterComponent } from './footer/footer.component';
import { NumberPipe } from './pipes/number.pipe';
import { ToNumberPipe } from './pipes/number.pipe';
import { FilterListPipe } from './pipes/filterList.pipe';
import { ExcelService } from './services/excel.service';
import { AccordionModule } from 'primeng/accordion';
import { BaseUtils } from './core/baseUtils.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MultiHierarchyDropdownComponent } from './component/multi-hierarchy-dropdown/multi-hierarchy-dropdown.component';
import { NewRangeSelectorComponent } from './component/new-range-selector/new-range-selector.component';
import { PresetModalComponent } from './preset-modal/preset-modal.component';
import { ListboxModule } from 'primeng/listbox';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { SidebarModule } from 'primeng/sidebar';
import { QrScannerComponent } from './component/qr-scanner/qr-scanner.component';

const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'value',
  optionTextField: 'label',
  keepSelectedItems: false
};
@NgModule({
  imports: [
    CommonModule,
    MalihuScrollbarModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgbModule,
    DropdownModule,
    TreeModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MultiSelectModule,
    NgxDaterangepickerMd.forRoot(),
    CalendarModule,
    FileUploadModule,
    ToastModule,
    TreeTableModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
    RouterModule,
    TranslateModule,
    AccordionModule,
    ListboxModule,
    NgxCaptchaModule,
    SidebarModule
  ],
  exports: [
    HeaderComponent, SideNavigationComponent, MalihuScrollbarModule, NewRangeSelectorComponent,
    SvgIconsDirective, NgbModule, DropdownModule, TableModule, FormsModule, DialogModule, MultiSelectModule, NgxSelectModule,
    BsDropdownModule, CalendarModule, ToastModule, TranslateModule, TreeModule, TreeTableModule,
    FileUploadModule, ResetPasswordComponent, ForgotPasswordComponent, NumberPipe, ToNumberPipe, AccordionModule,
    MultiHierarchyDropdownComponent, QrScannerComponent, FilterListPipe, PresetModalComponent, SidebarModule
  ],
  declarations: [
    HeaderComponent,
    SideNavigationComponent,
    SvgIconsDirective,
    InitialComponent,
    ResetPasswordComponent,
    MultiHierarchyDropdownComponent,
    QrScannerComponent,
    PageNotFoundComponent,
    ServerErrorComponent,
    AccessDeniedComponent,
    ServerUnavailableComponent,
    TimeOutComponent,
    NewRangeSelectorComponent,
    FooterComponent,
    NumberPipe,
    ToNumberPipe,
    FilterListPipe,
    PresetModalComponent,
    ForgotPasswordComponent
  ],
  providers: [
    SharedService,
    SideNavigationService,
    PageNotFoundService,
    ResetPasswordService,
    BaseUtils,
    ExcelService
  ]
})
export class SharedModule { }
